import React from "react";

import { AttributeCardDisplayVariantType } from "../types";

import AttributeSelectionCard from "@/Components/PersonalAttributes/Components/AttributeSelectionCard";
import { type AppUserSession } from "@/schemas/auth/session";
import {
  Ethnicity,
  UserEthnicityAttributeSet,
} from "@/schemas/profile/attributes/UserEthnicityAttributeSet";
import type { AttributeValue } from "@/schemas/attribute/AttributeSet";

type EthnicityProps = {
  session: AppUserSession;
  ethnicityValue: Ethnicity | null;
  variant: AttributeCardDisplayVariantType;
};

function EthnicitySelection({
  session,
  ethnicityValue: value,
  variant,
}: EthnicityProps): React.JSX.Element {
  const values = value ? [UserEthnicityAttributeSet.map[value]] : [];
  const typedValues = values.filter(
    (item): item is AttributeValue => item !== undefined,
  );

  return (
    <AttributeSelectionCard
      session={session}
      attribute={UserEthnicityAttributeSet}
      values={typedValues}
      icon="🗺️"
      variant={variant}
    />
  );
}

export default EthnicitySelection;
